
import { Base } from '../base-component';

import './value-proposition-item.component.scss';

export class ValuePropositionItem extends Base {

	constructor(element: Element){

		super(element);
				
	}

	init(){}

	bindEvents() {}

}



// WEBPACK FOOTER //
// ./components/value-proposition-item/value-proposition-item.component.ts